export const AUTH_SYNC_COOKIE_NAME = 'auth_sync';

export enum AuthSyncCookieStatus {
  TRUE = 'true',
  FALSE = 'false',
}
